import { render, staticRenderFns } from "./ContactItem.vue?vue&type=template&id=4c1c3236&scoped=true&"
import script from "./ContactItem.vue?vue&type=script&lang=js&"
export * from "./ContactItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1c3236",
  null
  
)

export default component.exports